import { useMemo } from 'react';
import { installMentPlans } from '@rb-serve-app/core';

interface UsePlanFiltersProps {
  installmentPlans?: installMentPlans[];
}

export const usePlanFilters = ({ installmentPlans }: UsePlanFiltersProps) => {
  return useMemo(() => {
    if (!installmentPlans) {
      return {
        activePlans: undefined,
        pendingPlans: undefined,
        completedPlans: undefined,
        cancelledPlans: undefined,
      };
    }

    const activePlans = installmentPlans.filter(
      (plan: any) => plan.planStatus === 'ACTIVE'
    );

    const pendingPlans = installmentPlans.filter(
      (plan: any) => plan.planStatus === 'PENDING'
    );

    const completedPlans = installmentPlans.filter(
      (plan: any) => plan.planStatus === 'CLOSED'
    );

    const cancelledPlans = installmentPlans.filter(
      (plan: any) => plan.planStatus === 'CANCELLED'
    );

    return {
      activePlans,
      pendingPlans,
      completedPlans,
      cancelledPlans,
    };
  }, [installmentPlans]);
};
